<template>
  <BaseLinksWidget heading="Solid Waste" :links="links"></BaseLinksWidget>
</template>

<script setup lang="ts">
import { useInternalLandingStore } from "@/components/internalLandingStore";
import { BaseLinksWidget } from "@modernary/mui/components/widgetGrid";
import { computed } from "vue";

const internalLandingStore = useInternalLandingStore();

const links = computed(() => internalLandingStore.solidWasteLinks);
</script>
